// extracted by mini-css-extract-plugin
export var carrierIcon = "_ya-0";
export var carrierLogo = "_ya-1";
export var detailsSection = "_ya-2";